<section class="new-translation" fxLayout fxLayoutAlign="center">
  <form #f="ngForm" (ngSubmit)="onSubmit(f)">
    <mat-grid-list cols="2" rowHeight="300px">
      <mat-grid-tile>
        <mat-card fxFlex.xs="100%" fxFlex="600px">
          <mat-card-title fxLayoutAlign="center" *ngIf="dealerService.dealerData.id"> Edit Dealer</mat-card-title>
          <mat-card-title fxLayoutAlign="center" *ngIf="!dealerService.dealerData.id"> Create Dealer</mat-card-title>
          <mat-card-content fxLayout="column">

            <mat-form-field>
              <input type="text" matInput placeholder="Name" [(ngModel)]="dealerService.dealerData.name" name="name" required
                     #Name="ngModel" />
              <mat-error *ngIf="Name.hasError('required')">Name cannot be empty</mat-error>
            </mat-form-field>
            <mat-form-field>
              <input type="text" matInput placeholder="Display Name" [(ngModel)]="dealerService.dealerData.displayName" name="displayName"
                     #DisplayName="ngModel" />
            </mat-form-field>
            <mat-form-field>
              <input type="text" matInput placeholder="Location" [(ngModel)]="dealerService.dealerData.location" name="location" required
                     #Location="ngModel" />
              <mat-error *ngIf="Location.hasError('required')">Location cannot be empty</mat-error>
            </mat-form-field>
            <mat-form-field>
              <input type="text" matInput placeholder="Display Location" [(ngModel)]="dealerService.dealerData.displayLocation" name="displayLocation"
                     #DisplayLocation="ngModel" />
            </mat-form-field>
            <mat-form-field>
              <input type="text" matInput placeholder="PostCode" [(ngModel)]="dealerService.dealerData.postCode" name="postCode"
                     #PostCode="ngModel" />
            </mat-form-field>
            <mat-form-field>
              <input type="text" matInput placeholder="Distance" [(ngModel)]="dealerService.dealerData.distance" name="distance"
                     #Distance="ngModel" />
            </mat-form-field>
            <mat-form-field>
              <input type="text" matInput placeholder="MaxCpc" [(ngModel)]="dealerService.dealerData.maxCpc" name="maxCpc"
                     #MaxCpc="ngModel" />
            </mat-form-field>
            <mat-form-field>
              <input type="text" matInput placeholder="SiteLinks" [(ngModel)]="dealerService.dealerData.siteLinks" name="siteLinks"
                     #SiteLinks="ngModel" />
            </mat-form-field>
            <mat-form-field>
              <input type="text" matInput placeholder="feedId" [(ngModel)]="dealerService.dealerData.feedId" name="feedId"
                     #feedId="ngModel" />
            </mat-form-field>
          </mat-card-content>
          <mat-card-actions fxLayoutAlign="center">
            <button type="submit" mat-raised-button color="primary">Submit</button>
            <button mat-raised-button color="warn" (click)="onClose()">Cancel</button>
          </mat-card-actions>
        </mat-card>
      </mat-grid-tile>
      <mat-grid-tile>
        <mat-card fxFlex.xs="100%" fxFlex="600px">
          <mat-card-title fxLayoutAlign="center" *ngIf="dealerService.dealerData.id"> Edit Dealer Adgroups</mat-card-title>
        </mat-card> 
      </mat-grid-tile>
    </mat-grid-list>
  </form>
</section>
